<template>
    <div class="card">
        <div v-if="beneficiary" class="card-content page-container">
            <div class="media">
                <div class="media-left">
                    <div v-if="beneficiary.gender == 'F'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                            <path fill="#92D3F5" d="M17 61v-4c0-5 5-9 10-9c6 5 12 5 18 0c5 0 10 4 10 9v4" />
                            <path fill="#F1B31C"
                                d="M18 47.3c1.1 1 2.4 1.9 3.6 2.7c1.7-1.2 3.6-2 5.4-2.1c6.2 5 12.5 5 18.7 0c1.4.1 2.9.6 4.2 1.5c1.1-.7 2.1-1.5 3-2.3c1.2-.7 3.1-8.3.4-13c-.4-.9-.8-1.7-1.2-2.6c-1.5-3.3-2-4.5-2.3-10.5c0-3.7-3.8-6.8-7.5-7.1c-.3 0-.5-.1-.7-.3c-.1-.1-2.4-2.7-7.2-2.7c-6.2 0-11.4 3.4-12.7 8.2c-.5 2-.7 4.1-.6 6.2c.2 2-.1 4.1-.8 6c-.2.8-.6 1.5-1.1 2.1c-3.8 4.3-1 14.2-1.2 13.9z" />
                            <path fill="#FCEA2B"
                                d="M25.4 29.4v1C25.4 38 30 44 35.9 44s10.5-6 10.5-13.6c0-4.7-1.8-7.5-5.3-11.1c-2.8 2.2-5.8 4.1-9 5.8c-2.6 1.4-6.3 3.5-6.7 4.3z" />
                            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M18.8 46.6c-3.7-5.9-.6-10.1 1.2-14.7c1.6-4.2-.2-6.5 1.3-12s7.3-9 13.7-9c5.4 0 8 3 8 3c4.2.4 7.4 3.9 7.4 8c.4 7.2 1 7.2 3.4 12.8c1.7 3.9 1.1 8.3-1.4 11.7M17 59.9v-3c0-5 5-9 10-9c6 5 12 5 18 0c5 0 10 4 10 9v3" />
                            <path
                                d="M42 29.9c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m-8 0c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2" />
                            <path fill="none" stroke="#000" stroke-linejoin="round" stroke-width="2"
                                d="M25 30.9c0 8 5 14 11 14s11-6 11-14c0-5-2-8-6-12c-4 4-16 9-16 11v1z" />
                            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M33 38.1c1.9 1 4.1 1 6 0" />
                        </svg>
                    </div>
                    <div v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                            <defs>
                                <path id="openmojiMan0"
                                    d="M41.9 30c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m-8 0c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2" />
                            </defs>
                            <path fill="#92D3F5" d="M17 61v-4c0-5 5-9 10-9c6 5 12 5 18 0c5 0 10 4 10 9v4" />
                            <path fill="#F1B31C" d="M26 38c-3 0-4-7-4-14c0-6 5-12 14-12s14 6 14 12c0 7-1 14-4 14" />
                            <path fill="#FCEA2B"
                                d="M24.9 31c-.1 8 4.1 14 11 14C43 45 47 39 47 31c0-5-3-10-3-10c-8 0-10 3-16 1c0 0-3 4-3.1 9z" />
                            <use href="#openmojiMan0" />
                            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M32.9 38.2c2.1.8 4.1.8 6 0M26 38c-3 0-4-7-4-14c0-6 5-12 14-12s14 6 14 12c0 7-1 14-4 14M17 60v-3c0-5 5-9 10-9c6 5 12 5 18 0c5 0 10 4 10 9v3" />
                            <use href="#openmojiMan0" />
                            <path fill="none" stroke="#000" stroke-linejoin="round" stroke-width="2"
                                d="M24.9 31c-.1 8 4.9 14 11 14c6 0 11.1-6 11.1-14c0-5-3-11-3-11c-8 0-10 3-16 1c0 0-3 5-3.1 10z" />
                            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M32.9 38.2c2.1.8 4.1.8 6 0" />
                        </svg>
                    </div>
                </div>
                <div class="media-content">
                    <p class="title is-4">{{ beneficiary.full_name }}</p>
                    <p class="subtitle is-6">{{ beneficiary.nric }}
                        <br>{{ beneficiary.date_of_birth }} | {{ beneficiary.race }} <span v-if="beneficiary.dietary_requirement">| {{ beneficiary.dietary_requirement }}</span>
                    </p>
                </div>
            </div>
            <div class="content">
                <nav class="level is-mobile">
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">ID</p>
                            <p class="title">{{ beneficiary.id }}
                            </p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Active</p>
                            <p class="title">
                                <span v-if="beneficiary.active">Yes
                                </span>
                                <span v-else>No
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Bag</p>
                            <p class="title">{{ beneficiary.quantity }} <span v-if="beneficiary.dry_bag"> D</span></p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Mode</p>
                            <p class="title">
                                <span v-if="beneficiary.driving_delivery">Driving</span>
                                <span v-else-if="beneficiary.self_collection">Self</span>
                                <span v-else>Walking</span>
                            </p>
                        </div>
                    </div>
                </nav>
                <p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="currentColor"
                            d="M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z" />
                    </svg>
                    {{ beneficiary.unit }}, {{ beneficiary.block }} {{ beneficiary.street }}, {{
                        beneficiary.postal_code }} ({{ beneficiary.location }})
                </p>
                <div class="justify-space-between">
                    <p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <g fill="none" fill-rule="evenodd">
                                <path
                                    d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
                                <path fill="currentColor"
                                    d="M16.552 22.133c-1.44-.053-5.521-.617-9.795-4.89c-4.273-4.274-4.836-8.354-4.89-9.795c-.08-2.196 1.602-4.329 3.545-5.162a1.47 1.47 0 0 1 1.445.159c1.6 1.166 2.704 2.93 3.652 4.317a1.504 1.504 0 0 1-.256 1.986l-1.951 1.449a.48.48 0 0 0-.142.616c.442.803 1.228 1.999 2.128 2.899c.901.9 2.153 1.738 3.012 2.23a.483.483 0 0 0 .644-.162l1.27-1.933a1.503 1.503 0 0 1 2.056-.332c1.407.974 3.049 2.059 4.251 3.598a1.47 1.47 0 0 1 .189 1.485c-.837 1.953-2.955 3.616-5.158 3.535Z" />
                            </g>
                        </svg>
                        {{ beneficiary.contact_number }}
                    </p>
                    <p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 256">
                            <path fill="currentColor"
                                d="M216 64h-40a48 48 0 0 0-96 0H40a16 16 0 0 0-16 16v120a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16ZM96 104a8 8 0 0 1-16 0V88a8 8 0 0 1 16 0Zm32-72a32 32 0 0 1 32 32H96a32 32 0 0 1 32-32Zm48 72a8 8 0 0 1-16 0V88a8 8 0 0 1 16 0Z" />
                        </svg>

                        
                        <span v-if="beneficiary.bag_status=='HAS_A_BAG'">Has a bag</span>
                        <span v-else-if="beneficiary.bag_status=='HAS_NO_BAG'">Has No bag</span>
                        <span v-else-if="beneficiary.bag_status=='NOT_RETURNED'" class="warning"> Not Returned ({{ beneficiary.bag_not_returned_counter }})</span>
                    </p>
                </div>
                <table class="table">
                    <tbody>
                        <tr v-if="beneficiary.driving_delivery">
                            <th>
                                Delivery Sort
                            </th>
                            <td>
                                {{ beneficiary.delivery_sort }}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Personal Info
                            </th>
                            <td>
                                <pre>{{ beneficiary.interview_personal }}</pre>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Financial Info
                            </th>
                            <td>
                                <pre>{{ beneficiary.interview_financial }}</pre>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Observations
                            </th>
                            <td>
                                <pre>{{ beneficiary.interview_observations }}</pre>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Remarks
                            </th>
                            <td>
                                <pre>{{ beneficiary.remarks }}</pre>
                            </td>
                        </tr>
                        <tr v-if="beneficiary.delivery_notes" class="has-background-warning-light">
                            <th class="has-text-warning-dark">
                                <span class="icon-text">
                                    <span class="icon"><i class="fas fa-sticky-note"></i></span>
                                    <span>Delivery Notes</span>
                                </span>
                            </th>
                            <td class="has-text-weight-semibold">
                                <pre>{{ beneficiary.delivery_notes }}</pre>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Interviewers
                            </th>
                            <td>
                                {{ beneficiary.approved_by }}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Date of interview
                            </th>
                            <td>
                                {{ beneficiary.date_of_approval }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <footer class="sticky-footer">
            <button class="button is-info is-rounded" @click="updateLink">
                Edit
            </button>
            
        </footer>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        }
    },
    created() {
        if (this.$store.getters['beneficiary/getBeneficiaries']) {
            if (!this.$store.getters['beneficiary/getBeneficiaries'].find(
                (beneficiary) => beneficiary.id === parseInt(this.id))) {
                this.loadBeneficiary();
            }
        } else {
            this.loadBeneficiary();
        }
    },
    computed: {
        beneficiary() {
            if (this.$store.getters['beneficiary/getBeneficiaries']) {
                return this.$store.getters['beneficiary/getBeneficiaries'].find(
                    (beneficiary) => beneficiary.id === parseInt(this.id)
                );
            }
            return null;
        }
    },
    methods: {
        async loadBeneficiary() {
            await this.$store.dispatch('beneficiary/loadBeneficiaries', {
                searchBy: 'id',
                searchTerm: this.id
            });
        },
        updateLink() {
            this.$router.push(this.id + "/update");
        }
    }
}
</script>

<style scoped>
.justify-space-between {
    display: flex;
    justify-content: space-between;
}
.warning {
    color: red;
}

pre {
    white-space: pre-wrap; /* Key for preserving newlines and wrapping */
    font-family: monospace; /* Ensures consistent spacing */
    border: 1px solid #ccc;
    padding: 5px;
    margin-top: 10px;
}

</style>